import { useMemo } from 'react';
import { useLanguage } from './useLanguage';
import { getContent, getContentByPath } from '@/utils/contentLoader';

/**
 * Hook to access content from content-ar.ts or content-en.ts
 * Provides a simple API to access typed content based on current language
 */
export const useContent = () => {
  const { language } = useLanguage();
  
  const content = useMemo(() => getContent(language), [language]);
  
  /**
   * Get content by path (e.g., 'home.hero.title' or 'common.services')
   * Supports dot notation for nested objects
   * @param path - The path to the content (e.g., 'home.hero.title')
   * @param options - Optional options object
   * @param options.returnObjects - If true, returns the object/array instead of empty string
   */
  const t = (path: string, options?: { returnObjects?: boolean }): string | any => {
    const value = getContentByPath(path, language);
    if (options?.returnObjects && (typeof value === 'object' || Array.isArray(value))) {
      return value;
    }
    return typeof value === 'string' ? value : '';
  };
  
  return {
    t,
    content,
    language,
  };
};

export default useContent;

